<template>
  <v-container>
    <template>
      <div
          class="ml-auto"
          :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 250px'"
        >
      <v-select
          v-model="filterTaskStatusSelected"
          :items="filterTaskStatusTypes"
          outlined
          item-value="value"
          item-text="tooltip"
          :label="languageData.select_task_status"
          @change="filterTasks($event)"
          return-object>
        <template slot='selection' slot-scope='{ item }'>
          {{ item.tooltip  }}
        </template>
        <template slot='item' slot-scope='{ item }'>
          {{ item.tooltip  }}
        </template>
      </v-select>
      </div>
    </template>
    <v-data-table
        loading-text="Loading..."
        class="mb-2"
        :loading="loadingTasks"
        :headers="headersTasks"
        :items="tasks"
        :options.sync="paginationTasks"
        :footer-props="footerOptions"
        :page.sync="currentPage"
        :server-items-length="totalItems"
        :items-per-page-options="rowsPerPageItems"
        :search="filterTaskStatusSelected.tooltip"
        mobile-breakpoint="0"
    >
      <template v-slot:item.status="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-select
                class="task-status-select"
                v-bind="attrs"
                v-on="on"
                v-model="taskStatusTypes.filter(el => el.value == item.status)[0]"
                @change="updateStatusTask($event, item)"
                :items="taskStatusTypes"
                item-value="value"
                item-text="tooltip"
                >
              <template slot='selection' slot-scope='{ item }'>
                {{ item.tooltip  }}
              </template>
              <template slot='item' slot-scope='{ item }'>
                {{ item.tooltip  }}
              </template>
            </v-select>
          </template>
        <span>{{ ProjectTaskIcon(item.status).tooltip }}</span>
      </v-tooltip>
      </template>
      <template v-slot:item.title="{ item }">
        <v-edit-dialog
            large
            @save="updateTask(item)"
            persistent
            :return-value.sync="item.title"
        > {{ item.title }}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
            >
              <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
            </v-btn> 
          </template>
          <span>{{ languageData.labels.edit }}</span>
        </v-tooltip>
          <template v-slot:input>
            <v-textarea
                class="mt-5"
                v-model="item.title"
                :label="languageData.labels.title"
                outlined
            ></v-textarea>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.description="{ item }">
        <v-edit-dialog
            large
            @save="updateTask(item)"
            persistent
            :return-value.sync="item.description"
        > {{ item.description }}
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
            >
              <v-icon size="18px" color="fontDefault" class="mb-1">edit</v-icon>
            </v-btn> 
          </template>
          <span>{{ languageData.labels.edit }}</span>
        </v-tooltip>
          <template v-slot:input>
            <v-textarea
                class="mt-5"
                v-model="item.description"
                :label="languageData.labels.description"
                outlined
            ></v-textarea>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                @click="editTask(item.id)"
                icon>
              <v-icon color="fontDefault">edit</v-icon>
            </v-btn>
          </template>
          <span>{{ languageData.operation.edit }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                @click="showDeleteProjectTaskModal(item)"
                icon>
              <v-icon color="fontDefault">delete</v-icon>
            </v-btn>
          </template>
          <span>{{ languageData.plannedContacts.deleteContact }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <ModalInfo :visDisAgreeBtn="true"
               @doOperation="removeTask(tasks.indexOf(taskToDelete), taskToDelete.id)"
               :typeInfo="'info'" :btnDisAgreeText="languageData.modalDeleteTask.btnDisAgreeText"
               :headModal="languageData.modalDeleteTask.head" :btnAgreeText="languageData.btnAgreeText"
               @clicked="hideModalContact" :show-modal="isShowModalDeleteProjectTask"
               :text-modal="languageData.modalDeleteTask.textInfo + ' ' + taskToDelete.title">
    </ModalInfo>
  </v-container>
</template>

<script type="text/javascript">
import {mapActions, mapState} from "vuex";
import ModalInfo from "../../../components/ModalInfo/ModalInfo";
import eventBus from "../../../event-bus/eventBus";
import taskStatusTypes from "../enums/taskStatusTypes";

export default {
  name: "ProjectTasksTable",
  components: {
    ModalInfo
  },
  data() {
    return {
      footerOptions: {
        'items-per-page-options': [5, 15, 30],
        'disablePagination': false
      },
      currentPage: 1,
      tasks: [],
      taskToDelete: {},
      statusTaskSelected: { value: null },
      filterTaskStatusSelected: { 
        value: 3,
        tooltip: 'All',
        name: 'All' 
        },
    }
  },
  computed: {
    ...mapState("getProjectTasks", {
      projectTasksReceive: state => state.dataReceive,
      totalItems: state => state.pagination.totalItems,
      rowsPerPageItems: state => state.pagination.rowsPerPage,
      sortBy: state => state.pagination.sortBy,
      loadingTasks: state => state.loadingTasks
    }),
    ...mapState("deleteProjectTask", {
      isShowModalDeleteProjectTask: state => state.isShowModalDeleteProjectTask
    }),
    ...mapState("getHeadersProjectTasks", {
      headersTasks: state => state.headers
    }),
    paginationTasks: {
      set: function (value) {
        value.search = this.filterTaskStatusSelected.value;
        this.searchProjectTask(value);
      },
      get: function () {
        return {
            page: 1,
            rowsPerPage: 20,
            totalItems: null,
            sortBy: [""],
            sortDesc: [""],
            current: 1
        }
      }
    },
    taskStatusTypes() {
      return taskStatusTypes.data;
    },
    filterTaskStatusTypes() {
      const all = [
        {
          name: 'All',
          value: 3,
          tooltip: 'All'
        }
      ]
      return all.concat(taskStatusTypes.data);
    }
  },
  methods: {
    ...mapActions("getHeadersProjectTasks", ["getHeadersProjectTasks"]),
    ...mapActions("deleteProjectTask", ["deleteProjectTask", "updateVisibleModalDeleteProjectTask"]),
    ...mapActions("updateProjectTask", ["updateProjectTask"]),
    ...mapActions("getProjectTasks", ["getProjectTasks"]),
    ...mapActions("updateVisibleProjectTaskModal", ["updateVisibleProjectTaskFormModal"]),
    ...mapActions("getProjectTask", ["getProjectTask"]),
    ...mapActions("getTodoTasks", ["getTodoTasks"]),

    searchProjectTask: function (valueSearch = {}, filters = false) { 
      valueSearch.language = this.getCurrentLanguage;
      valueSearch.filters = filters;
      this.getProjectTasks({valueSearch});
      if (filters) {
        this.currentPage = 1;
      }
    },
    ProjectTaskIcon(state) {
        return this.status[state];
    },
    removeTask: function (index, id) {
      this.tasks.splice(index, 1);
      this.deleteProjectTask({creds: {id}});
    },
    showDeleteProjectTaskModal: function (item) {
      this.taskToDelete = item;
      this.updateVisibleModalDeleteProjectTask(true);
    },
    hideModalContact: function () {
      this.updateVisibleModalDeleteProjectTask(false);
    },
     updateStatusTask: function (event, item) {
      let id = item.id;
      let data = item;
      data.status = event;
      data.projectId = this.projectSelected;
      this.updateProjectTask({creds: {id, data}});
    },
    editTask: function (taskId) {
      this.updateVisibleProjectTaskFormModal([true, 'edit']);
      this.getProjectTask({creds: {id: taskId}});
    },
    updateTask: function (data) {
      let id = data.id;
      this.updateProjectTask({creds: {id, data}});
    },
    filterTasks: function(event) {
      this.filterTaskStatusSelected = event
      this.searchProjectTask({search: event.value}); 
    },
  },
  mounted() {
    const language = this.getCurrentLanguage;

    taskStatusTypes.updateLanguage(this.languageData);
    this.status = taskStatusTypes.data;

    this.getHeadersProjectTasks({creds: {language}});

    eventBus.$on("setDisablePagination", (value) => {
      this.footerOptions.disablePagination = value;
    });

    eventBus.$on("getTasksSuccess", (data) => {
      this.tasks = data;
    });

    eventBus.$on("updateProjectTaskSuccess", () => {
      this.searchProjectTask({});
    });

    eventBus.$on("deleteProjectTaskSuccess", () => {
      this.searchProjectTask({});
    });

    eventBus.$on("getProjectTasks", () => {
      this.tasks = [];
      this.searchProjectTask({});
    });

  },
  beforeDestroy() {
    eventBus.$off('updateProjectTaskSuccess');
    eventBus.$off('saveProjectTaskSuccess');
    eventBus.$off('getProjectTasks');
    eventBus.$off('getTasksSuccess');
  }

}
</script>